@if (!lma.isLoading() && lma.error()) {
  <app-error-component [enableRetry]="true" (clickRetry)="lma.reload()" class="block h-70" />
} @else {
  <div
    class="grid grid-cols-1 @xl/main:grid-cols-2 @4xl/main:grid-cols-3 @6xl/main:grid-cols-4 gap-5"
  >
    @if (lma.isLoading()) {
      <app-document-lma-card-skeleton />
      <app-document-lma-card-skeleton />
      <app-document-lma-card-skeleton />
    } @else if (lma.hasValue()) {
      @for (document of lma.value().items; track document.id) {
        <app-document-lma-card [document]="document" (clickOpen)="clickOpen.emit(document.id)" />
      }
    }

    <div
      class="px-6 pt-5 pb-4 flex flex-col items-center justify-center gap-5 h-90 bg-surface dark:bg-surface-darkmode rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode outline-dashed"
    >
      <ui-button
        mode="outlined"
        notImplemented
        [notImplementedTitle]="'cockpit.analysis.lma.contactDialog.title' | transloco"
        [notImplementedMessage]="'cockpit.analysis.lma.contactDialog.message' | transloco"
      >
        <ng-icon name="heroPlus" size="20" slot="start" class="!block" />
        {{ 'cockpit.documents.lma.request' | transloco }}
      </ui-button>
    </div>
  </div>
}
